import { useQuery } from '@tanstack/react-query';
import { serverRequest } from '../../util/server_request';
import { notifyUser } from '../../util/util';

export const memberRequestKeys = {
  all: ['memberRequests'],
  list: (page, size) => [...memberRequestKeys.all, 'list', { page, size }],
};

export const useMemberRequests = (page = 0, size = 10) => {
  return useQuery({
    queryKey: memberRequestKeys.list(page, size),
    queryFn: async () => {
      const result = await serverRequest(
        'GET',
        `members/gcb/request/all?page=${page}&size=${size}`
      );
      return result.data;
    },
    keepPreviousData: true,
    onError: (error) => {
      notifyUser('error', error, 'Error');
    },
  });
};
